import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { StateService } from '@adreno-common';
import { environment } from '@environments/environment';
import { GetTZDataChildDto, GetTZDataVm } from '../models';
import { filter, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class TimezoneService extends StateService<TZState> {
  private recordsApi = `${environment.apiPath}/records`;

  private timezones$ = this.select((state) => state.timezones);

  constructor(private http: HttpClient) {
    super(initalTZState);

    this.loadTimezones();
  }
  getContactUTCOffset$(state: string, country?: string) {
    if (country?.toUpperCase() === 'NEW ZEALAND') state = 'NZ';
    if (country?.toUpperCase() === 'UNITED KINGDOM') state = 'UK';
    if (country?.toUpperCase() === 'CANADA') state = 'BC';
    if (country?.toUpperCase() === 'FIJI') state = 'FJ';

    return this.timezones$.pipe(
      filter((timezones) => !!timezones),
      map(
        (timezones) =>
          timezones.find((tz) => tz.state === state.toUpperCase())?.utcOffset
      )
    );
  }

  loadTimezones() {
    this.http
      .get<GetTZDataVm>(`${this.recordsApi}/timezones`)
      .subscribe((vm) => {
        this.state = { timezones: vm.timezones };
      });
  }
}

export interface TZState {
  timezones: GetTZDataChildDto[];
}

export const initalTZState: TZState = {
  timezones: [],
};
